import { render, staticRenderFns } from "./attend-class.vue?vue&type=template&id=b6c67fe6&scoped=true"
import script from "./attend-class.vue?vue&type=script&lang=js"
export * from "./attend-class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c67fe6",
  null
  
)

export default component.exports